// Metrics the API only calculates when a request names them in `include`. Replace this with the API's `on_demand`
// metric flag once it exists. Separate from the AI summary's list of metrics without percentile support.
export const ON_DEMAND_METRIC_KEYS = ['max_speed'] as const;

export type OnDemandMetricKey = (typeof ON_DEMAND_METRIC_KEYS)[number];

export type OnDemandIncludeParams = { include?: OnDemandMetricKey[] };
